import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import tr from './config/lang/tr.json';
import fa from './config/lang/fa.json';
import ar from './config/lang/ar.json';

// Get saved language from localStorage (default to 'fa' if not set)
const savedLang = localStorage.getItem('language') || 'tr';

i18n.use(initReactI18next).init({
    resources: {
        tr: { translation: tr },
        fa: { translation: fa },
        ar: { translation: ar },
    },
    lng: savedLang,
    fallbackLng: 'tr',
    interpolation: {
        escapeValue: false,
    },
});

// Set HTML direction (rtl/ltr) at startup
document.dir = ['fa', 'ar'].includes(savedLang) ? 'rtl' : 'ltr';
document.documentElement.lang = savedLang;
export default i18n;
